/** Direction A “3D mascot” mark from the Datamint assistant identity brief. */
export function MintiMascot({
  className = "h-8 w-8",
  title = "Minti",
}: {
  className?: string;
  title?: string;
}) {
  return (
    <svg
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      className={className}
    >
      <circle cx="100" cy="88" r="46" fill="#52C878" />
      <path
        d="M70 60Q82 74 70 86M130 60Q118 74 130 86"
        stroke="#3A9B58"
        strokeWidth="2"
        fill="none"
      />
      <circle cx="86" cy="82" r="11" fill="#fff" />
      <circle cx="116" cy="82" r="11" fill="#fff" />
      <circle cx="88" cy="84" r="5" fill="#1B3D2F" />
      <circle cx="118" cy="84" r="5" fill="#1B3D2F" />
      <path
        d="M84 106Q100 120 116 106"
        stroke="#1B3D2F"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M54 74a46 46 0 0 1 0 28"
        stroke="#1B3D2F"
        strokeWidth="9"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M146 74a46 46 0 0 0 0 28"
        stroke="#1B3D2F"
        strokeWidth="9"
        fill="none"
        strokeLinecap="round"
      />
      <rect x="64" y="134" width="72" height="36" rx="11" fill="#1B3D2F" />
      <text
        x="100"
        y="157"
        textAnchor="middle"
        fontFamily="Inter,sans-serif"
        fontSize="12"
        fill="#52C878"
      >
        minti
      </text>
    </svg>
  );
}
